import { createSelector, createStructuredSelector } from 'reselect';
import _ from 'lodash';
import { isPlural, parsePlural } from 'utils/plural';
import { language } from 'selectors/configuration';

function getTranslate(keyString, params, lang, translateData) {
  let result = ((translateData && translateData[keyString]) || keyString).trim();
  if (isPlural(result)) {
    return parsePlural(lang, result, params);
  }
  _.forEach(params, (value, paramKey) => {
    result = result.replace(`{${paramKey}}`, value);
  });
  return result;
}

export const translateData = (state) => state.translate;

export const translate = createSelector(translateData, language, (data, lang) => (key, params) =>
  getTranslate(key, params, lang, data)
);

export default createStructuredSelector({
  translateData,
  translate,
});
